export default __webpack_public_path__ + "static/media/image.f0166e8d.png";